import { useExtractDocs } from "context/ExtractDocsContext";
import { isVoiceSourceDocumentSource } from "core/model/files/utils";
import { VoiceTranscriptFile } from "core/types";
import { useMemo } from "react";

/**
 * Voice transcripts are AI-core-only documents (no backing Filev2/HIS row).
 * Derives read-only rows for them from the current extract status so they
 * can be surfaced in the files table and looked up for the details modal.
 */
export function useVoiceTranscriptFiles(): VoiceTranscriptFile[] {
  const { extractOcrStatus } = useExtractDocs();

  return useMemo(
    () =>
      (extractOcrStatus.result?.documents ?? [])
        .filter((doc) => isVoiceSourceDocumentSource(doc.source))
        .map((doc) => ({
          created_at: doc.uploaded_at ?? 0,
          filename: doc.filename,
          id: doc.document_id,
          processed_document_uri: doc.processed_document_uri,
          source: doc.source,
          status: doc.status,
        })),
    [extractOcrStatus.result?.documents],
  );
}
